import { render, staticRenderFns } from "./StatusVerifiedDetails.vue?vue&type=template&id=c6c6f650&scoped=true&"
import script from "./StatusVerifiedDetails.vue?vue&type=script&lang=js&"
export * from "./StatusVerifiedDetails.vue?vue&type=script&lang=js&"
import style0 from "./StatusVerifiedDetails.vue?vue&type=style&index=0&id=c6c6f650&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c6f650",
  null
  
)

export default component.exports